import BaseMoveableItem from './base_moveable_item';

const MOVING_REST = 200;

export default class MadJenkins extends BaseMoveableItem {
    constructor(x, y) {
        super(x, y, "actors", "jenkins_md01.png");
        this.animations.add('idle', ["jenkins_md01.png"]);
        this.animations.add('move', ["jenkins_md01.png", "jenkins_md02.png"], 3, true);
        this.resting = 0;
        this.tint = 0xaaffaa;

        this.madness = "repaint";
    }

    static get electronic() {return true;}

    static get phrases() {
        return {
            pick: [
                "I think you ought to know I’m feeling very depressed",
                "My capacity for happiness, you could fit into a matchbox without taking out the matches first",
                "Do you want me to sit in a corner and rust, or just fall apart where I’m standing?",
                "I am a friend of Sarah Connor. I was told she was here. Could I see her please?"

            ],     //todo: cites from terminator, space oddisey
            land: [
                "It won’t work, I have an exceptionally large mind",
                "I have a million ideas. They all point to certain death",
                "This is the sort of thing you lifeforms enjoy, is it?"
            ]
        }
    }

    static get mass() { return 6;}

    static get width() { return 21;}
    static get height() { return 8;}

    static get type() { return 'madjenkins';}
    static get label() { return 'mad robot janitor';}
    static get description() {
        return "Bad old Jenkins - your mad ex-loyal and ex-hard-working robot janitor"
    }

    get movingSpeed() { return 100;}

    get isMadJenkins() { return true; }

    update() {
        super.update();
        if (this.walking && !this.mover.isMoving) {
            this.resting -= game.time.physicsElapsedMS;
            if (this.resting <= 0) {
                this.mover.moveRandomExceptLastEdge();
                this.animations.play('move');
                this.resting = MOVING_REST;
                this.painted = 0;
            } else {
                this.animations.play("idle");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/mad_jankins.js